import type { AirHandlerProductType, SystemOptionZoneType } from 'data/types';

export type DuctedIndoorUnitType = {
  key: string;
  product: AirHandlerProductType;
};

export function getDuctedIndoorUnits(
  zone: SystemOptionZoneType | undefined
): DuctedIndoorUnitType[] {
  if (!zone) return [];
  const units: DuctedIndoorUnitType[] = [
    { key: `${zone.uniqueId}-indoor`, product: zone.selectedProduct }
  ];
  if (zone.blowerProduct) {
    units.push({ key: `${zone.uniqueId}-blower`, product: zone.blowerProduct });
  }
  return units;
}
